module.exports = __webpack_public_path__ + "images/help_v2/avatars/seandong-97beb60560b074b5d3573666613b1ba3.png";